import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navbar } from 'reactstrap';
import { getCategories } from '../../actions/Categories';
import CONSTANTS from '../../constants';
import ScrollHelper from '../../helpers/ScrollHelper';
import Category from './Category';

class Categories extends Component {
  componentDidMount() {
    this.props.getCategories(
      this.props._location.menu_blob,
      this.props._location.loc_id,
      this.props.history
    );
    window.addEventListener('scroll', ScrollHelper.onScroll);
    // document.onclick = ScrollHelper.scrollTo;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', ScrollHelper.onScroll);
    // document.onclick = ScrollHelper.scrollTo;
  }

  render() {
    let { categories, items } = this.props;
    if (categories?.length === 1) {
      let categorySearch = document.getElementsByClassName('category-search-input-section');
      if (categorySearch.length > 0) {
        categorySearch[0].style.display = 'flex';
      }
    }
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
    if (categories) {
      return (
        <Navbar
          className={
            categories.length > 0
              ? 'horizontal-scroll category-list card-color ps-3 hovernowshodow ' + card_outline
              : 'horizontal-scroll category-list hide-category-list card-color hovernowshodow ' + card_outline
          }
          id="categories"
        >
          <Category
            key="popular"
            _location={this.props._location}
            category={{
              category_id: CONSTANTS.MENU.POPULAR_CATEGORY,
              name: 'Popular'
            }}
          />
          {this.renderCategories(categories, this.props.items)}
        </Navbar>
      );
    }
    return '';
    // TODO Return Spinner Component
  }

  getMenuStatusForItem(item, selectedOutlet) {
    let outlet;
    if (!this.props.outlets) {
      return item.menu_status;
    }
    for (const o of this.props.outlets) {
      if (this.props._location.loc_id === o.loc_id) {
        outlet = o;
        break;
      }
    }
    const outlet_status = outlet && outlet.stockStatuses[item.menu_id];
    if (outlet_status) {
      return outlet_status.status_id;
    }
    return item.menu_status;
  }

  renderCategories(categories, items) {
    if (items) {
      for (let item of items) {
        item.menu_status = this.getMenuStatusForItem(item, this.props.selectedOutlet);
      }
    }
    const menuByCategory = (menu_category_id) => {
      if (this.props.selectedOutlet?.outstock_items_visibility === 1) {
        return items.filter((p) => p.menu_category_id === menu_category_id && (p.menu_status === 1 || p.menu_status === 2));
      } else {
        return items.filter((p) => p.menu_category_id === menu_category_id && (p.menu_status === 1));

      }
    };
    return categories.map((category) => {
      let outlet = this.props.selectedOutlet;
      if (outlet?.is_outlet) {
        for (const o of this.props.outlets) {
          if (outlet.loc_id === o.loc_id) {
            outlet = o;
            break;
          }
        }
      }
      if (outlet) {
        let categoryStatuses = outlet?.categoryStatuses;
        if (
          categoryStatuses &&
          categoryStatuses[category.category_id] &&
          categoryStatuses[category.category_id].status_id === 0
        ) {
          return null;
        }
        if (menuByCategory(category.category_id).length === 0) {
          return null
        }
      }
      return <Category key={category.category_id} category={category} />;
    });
  }
}

function mapStateToProps(state) {
  const { location, items, locationSettings, categories, childLocations } = state;
  return {
    _location: location, items, locationSettings, categories, outlets: childLocations,
  };
}

export default connect(mapStateToProps, { getCategories })(Categories);
